// Curated media for the orbiting universe & promos.
export const ISACK_AVATAR =
  "https://images.unsplash.com/photo-1782572129042-0bf6176fe83f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBhZnJpY2FuJTIwaG90ZWwlMjBjb25jaWVyZ2UlMjBwcm9mZXNzaW9uYWwlMjBzbWlsaW5nfGVufDB8fHx8MTc4NzgxOTAxMHww&ixlib=rb-4.1.0&q=85";

export const ALPHARD_IMG =
  "https://images.unsplash.com/photo-1558101847-e017d5e414a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHx0b3lvdGElMjBhbHBoYXJkJTIwbHV4dXJ5JTIwdmFuJTIwYmxhY2t8ZW58MHx8fHwxNzg3ODE5MDEwfDA&ixlib=rb-4.1.0&q=85";

// Real brand photos (uploaded by owner).
const CDN = "https://customer-assets-0z36b82j.emergentagent.net/job_zanzibar-isack/artifacts";
export const FLEET_PRADO = `${CDN}/41kwbz8e_stone9.webp`;     // Black Prado at Old Fort, Stone Town
export const SPICE_VANILLA = `${CDN}/vkvrv5so_ston8.jpeg`;    // Fresh vanilla pods
export const SPICE_CINNAMON = `${CDN}/bttqfp9s_stone6.jpeg`;  // Cinnamon bark
export const STONE_CATHEDRAL = `${CDN}/6jp79luy_stone1.webp`; // St Joseph's Cathedral

export const EXPERIENCES = [
  {
    key: "Safari Blue",
    label: "Safari Blue",
    img: "https://images.unsplash.com/photo-1635161517743-89eac39505d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHx6YW56aWJhciUyMHNhZmFyaSUyMGJsdWUlMjBvY2VhbiUyMGRob3clMjBib2F0fGVufDB8fHx8MTc4NzgxOTAxMHww&ixlib=rb-4.1.0&q=85",
    prompt: "Tell me about the Safari Blue experience.",
  },
  {
    key: "Spice Tour",
    label: "Spice Tour",
    img: `${CDN}/vkvrv5so_ston8.jpeg`,
    prompt: "I'd love to hear about the Spice Tour.",
  },
  {
    key: "Dolphin Tour",
    label: "Dolphins",
    img: "https://images.unsplash.com/photo-1580072624564-1fe6b660b7e2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxkb2xwaGlucyUyMG9jZWFuJTIwY2xlYXIlMjB3YXRlcnxlbnwwfHx8fDE3ODc4MTkwMTB8MA&ixlib=rb-4.1.0&q=85",
    prompt: "Tell me about the Dolphin Tour.",
  },
  {
    key: "Sunset Cruise",
    label: "Sunset Cruise",
    img: "https://images.unsplash.com/photo-1511684633137-6b5fc88b3dbc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHx6YW56aWJhciUyMHN1bnNldCUyMGNydWlzZSUyMGRob3d8ZW58MHx8fHwxNzg3ODE5MDEwfDA&ixlib=rb-4.1.0&q=85",
    prompt: "I'm interested in a romantic Sunset Cruise.",
  },
  {
    key: "Nungwi Tour",
    label: "Nungwi",
    img: "https://images.unsplash.com/photo-1545583477-39bccc07119d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxOdW5nd2klMjBaYW56aWJhciUyMHR1cnF1b2lzZSUyMGJlYWNofGVufDB8fHx8MTc4NzgxOTg1Nnww&ixlib=rb-4.1.0&q=85",
    prompt: "What can I do on a Nungwi tour?",
  },
  {
    key: "Town Tour",
    label: "Stone Town",
    img: `${CDN}/6jp79luy_stone1.webp`,
    prompt: "Tell me about the Stone Town Tour.",
  },
  {
    key: "Jozani Forest",
    label: "Jozani",
    img: "https://images.unsplash.com/photo-1627492722164-f1a980b0aee8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxKb3phbmklMjBmb3Jlc3QlMjBncmVlbiUyMHRyb3BpY2FsJTIwWmFuemliYXJ8ZW58MHx8fHwxNzg3ODE5ODU2fDA&ixlib=rb-4.1.0&q=85",
    prompt: "Tell me about Jozani Forest.",
  },
];
